import TYPES from '../../types';

// Domain
import { CustomerBankAccountDto } from '../../domain/dtos/customer-bank-account-dto';
import { CustomerBankAccountRepository } from '../../domain/repositories/customer-bank-account-repository';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import Command from '@/modules/shared/domain/use-cases/command';

@Injectable()
export default class UpdateCustomerBankAccountCommand extends Command<CustomerBankAccountDto> {
  @Inject(TYPES.CUSTOMER_BANK_ACCOUNT_REPOSITORY)
  private readonly repository!: CustomerBankAccountRepository;

  internalExecute(payload: CustomerBankAccountDto): Promise<void> {
    return this.repository.update(payload);
  }
}
